// 商品 - 商品圖幻燈片
'use client';
import { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Thumbs, FreeMode, Mousewheel } from 'swiper/modules';
import type { Swiper as SwiperClass } from 'swiper/types';
import Image from 'next/image';
import { cn } from '@/common/util';
import 'swiper/css';
import 'swiper/css/thumbs';
import 'swiper/css/free-mode';
import ItemShare from './ItemShare'; // 商品分享

interface Props {
    images: string[];
    productName?: string;
}

const ItemSwiper = ({ images = [], productName = '' }: Props) => {
    // 縮圖 swiper 實例（用來連動大圖）
    const [thumbsSwiper, setThumbsSwiper] = useState<SwiperClass | null>(null);
    // 當前所在的 index
    const [activeIndex, setActiveIndex] = useState(0);

    return (
        <div className="w-full shrink-0 space-y-3 lg:w-107.5">
            {/* 大圖輪播 */}
            <div className="lg:px-0 px-4">
                <Swiper
                    className="w-full aspect-square overflow-hidden rounded-md"
                    modules={[Thumbs]}
                    thumbs={{ swiper: thumbsSwiper }}
                    onSlideChange={(swiper) => setActiveIndex(swiper.activeIndex)}
                >
                    {images.map((img, i) => (
                        <SwiperSlide key={img + i}>
                            <div className="img-box w-full h-full">
                                <Image
                                    width={430}
                                    height={430}
                                    src={img}
                                    alt={`item-${i}`}
                                    className="object-cover"
                                />
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>

            {/* 小圖輪播 */}
            {images.length > 1 && (
                <Swiper
                    className="w-full pl-4"
                    modules={[Thumbs, FreeMode, Mousewheel]}
                    onSwiper={setThumbsSwiper}
                    slidesPerView="auto"
                    spaceBetween={2}
                    freeMode
                    watchSlidesProgress
                    grabCursor
                    mousewheel={{ forceToAxis: true }}
                    breakpoints={{
                        0: {
                            slidesOffsetBefore: 16,
                        },
                        1024: {
                            slidesOffsetBefore: 0,
                        },
                    }}
                >
                    {images.map((img, i) => (
                        <SwiperSlide key={img + i} className="w-11.5! cp">
                            <div
                                className={cn(
                                    'img-box w-11.5 aspect-square rounded-md overflow-hidden border-2 border-transparent',
                                    activeIndex === i && 'border-vPurple'
                                )}
                            >
                                <Image
                                    width={46}
                                    height={46}
                                    src={img}
                                    alt={`item-thumb-${i}`}
                                    className="object-cover"
                                />
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            )}

            {/* 分享列 */}
            <ItemShare productName={productName} />
        </div>
    );
};

export default ItemSwiper;
